<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';

const props = defineProps({
  keepAlive: {
    type: Boolean,
    default: true,
  },
});

const route = useRoute();
const isFullWidth = computed(() => route.meta?.fullWidth === true);
</script>

<template>
  <div
    class="flex flex-col w-full h-full m-0 pb-8 pt-4 px-6 overflow-auto bg-n-surface-1"
  >
    <div
      class="flex items-start w-full"
      :class="isFullWidth ? '' : 'max-w-5xl mx-auto'"
    >
      <router-view v-slot="{ Component }">
        <keep-alive v-if="props.keepAlive">
          <component :is="Component" :key="route.fullPath" />
        </keep-alive>
        <component :is="Component" v-else :key="route.fullPath" />
      </router-view>
    </div>
  </div>
</template>
